import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Drawer,
  IconButton,
  Box,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { LoginButton } from '../login-button/login-button.component';
import { ReactComponent as Logo } from '../../assets/logos/solid/white/vertical.svg';
import { Link } from 'react-router-dom';

export const DrawerMenu = ({
  toggleDrawer,
  open,
  user,
  handleOpenUserMenu,
  navigate,
  pages,
}) => {
  const theme = useTheme();
  return (
    <Drawer
      open={open}
      onClose={toggleDrawer(false)}
      anchor="right"
      keepMounted
      disableScrollLock
      sx={{
        '& .MuiDrawer-paper': {
          backgroundColor: `${theme.palette.primary.main}`,
          color: 'white',
          padding: { xs: '0.5rem', sm: '1rem' },
          height: '100%',
          width: '100%',
          overscrollBehavior: 'contain',
          WebkitOverflowScrolling: 'touch',
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginBottom: '1rem',
        }}
      >
        <IconButton
          onClick={toggleDrawer(false)}
          sx={{
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <Close
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          gap: '2rem',
        }}
      >
        <Logo style={{ width: '100%', maxWidth: '180px' }} />
        <LoginButton
          user={user}
          handleOpenUserMenu={handleOpenUserMenu}
          navigate={navigate}
          toggleDrawer={toggleDrawer}
        />
      </Box>
      <List
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        {pages.map((page, index) => (
          <ListItem key={page.title + index} disablePadding>
            <ListItemButton
              component={page.url ? Link : 'button'}
              to={page.url || ''}
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
              onClick={() => {
                toggleDrawer(false)();
              }}
            >
              <ListItemText
                primary={page.title}
                sx={{
                  '& .MuiListItemText-primary': {
                    color: 'white',
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};
